import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { AdmissionPacketWorkspace } from "@/components/app/admission-packet/packet/workspace";
import { orpc } from "@/lib/orpc";

export const Route = createFileRoute("/_authenticated/_workforce/hr/delegation-packets/$packetId")({
  component: DelegationPacketWorkspace,
});

/** An employee's RN delegation packet, in the same workspace every other packet uses. It is an
 * admission packet in all but subject, so giving it a screen of its own would mean a second copy of
 * the intake, the signing plan and the links — and the two would drift. */
function DelegationPacketWorkspace() {
  const { packetId } = Route.useParams();
  const navigate = useNavigate();
  // Read so "back" lands on the person whose file this is, rather than on the
  // employee picker. The workspace asks for the same packet, and React Query
  // answers both from one request.
  const packet = useQuery(orpc.care.admissions.get.queryOptions({ input: { packetId } }));
  return (
    <AdmissionPacketWorkspace
      key={packetId}
      packetId={packetId}
      onOpenPacket={(next) =>
        navigate({
          to: "/hr/delegation-packets/$packetId",
          params: { packetId: next },
        })
      }
      back={
        <Link
          to="/hr/employees"
          search={{ employeeId: packet.data?.employeeUserId ?? undefined }}
          className="hover:underline"
        >
          Back to the employee file
        </Link>
      }
    />
  );
}
